export default function getRequestHeaders(data) {
  const {
    requestHasFilesFlag,
    requestDownloadFilesFlag,
    requestBlobFlag,
    ...params
  } = data || {};

  // JSON.stringify the filters object if present, as the server expects a JSON string
  const processedParams = params.filters
    ? { ...params, filters: JSON.stringify(params.filters) }
    : params;

  return Object.assign(
    {
      headers: requestHasFilesFlag
        ? {
            "Content-Type": "multipart/form-data",
          }
        : {
            "Content-Type": "application/json",
          },
    },
    data && { params: processedParams },
    requestDownloadFilesFlag && { responseType: "arraybuffer" },
    requestBlobFlag && { responseType: "blob" }
  );
}
